if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          const button = mediaToSwitch.querySelector('button');
          const mediaId = mediaToSwitch.dataset.target;
          button.addEventListener('click', this.setActiveMedia.bind(this, mediaId, false));
          button.addEventListener('pointerdown', this.primeMedia.bind(this, mediaId), { passive: true });
          button.addEventListener('pointerenter', this.primeMedia.bind(this, mediaId), { passive: true });
          button.addEventListener('focus', this.primeMedia.bind(this, mediaId), { passive: true });
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.primeMedia(mediaId);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        const slider = this.elements.thumbnails.slider;
        const isVertical = this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches;

        if (isVertical) {
          const sliderRect = slider.getBoundingClientRect();
          const thumbnailRect = thumbnail.getBoundingClientRect();
          const isVisible = thumbnailRect.top >= sliderRect.top + 10 && thumbnailRect.bottom <= sliderRect.bottom - 10;
          if (isVisible) return;

          const top = thumbnail.offsetTop - Math.max(0, (slider.clientHeight - thumbnail.offsetHeight) / 2);
          slider.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          return;
        }

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        slider.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;

        const announce = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };

        if (image.complete) {
          announce();
        } else {
          image.addEventListener('load', announce, { once: true });
        }
      }

      primeMedia(mediaId) {
        const media = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        const image = media?.querySelector('.product__modal-opener--image img');
        if (!image) return;

        const deferredSrcset = image.getAttribute('data-product-srcset');
        const deferredSrc = image.getAttribute('data-product-src');

        if (deferredSrcset) image.setAttribute('srcset', deferredSrcset);
        if (deferredSrc) image.setAttribute('src', deferredSrc);

        image.removeAttribute('data-product-srcset');
        image.removeAttribute('data-product-src');
        image.removeAttribute('data-product-media-deferred');

        if (image.complete) return;
        image.loading = 'eager';
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
